import React from 'react';
import PropTypes from 'prop-types';
import { Stack, TextField, MenuItem } from '@metarouter-private/mr-mui';
import { useQueryWebhookEventTypes, DELIVERY_LOG_STATUS } from '@ion/api';
import formatEventType from './formatEventType';

export default function DeliveryLogsFilters({ filters, onFilterChange }) {
  const { eventTypes } = useQueryWebhookEventTypes();

  const handleEventTypeChange = event => {
    onFilterChange({ ...filters, eventType: event.target.value || null });
  };

  const handleStatusChange = event => {
    onFilterChange({ ...filters, status: event.target.value });
  };

  return (
    <Stack direction="row" spacing={2}>
      <Stack width={200}>
        <TextField
          select
          label="Event Type"
          value={filters.eventType ?? ''}
          onChange={handleEventTypeChange}
          size="small"
          fullWidth
        >
          <MenuItem value="">All Events</MenuItem>
          {eventTypes.map(eventType => (
            <MenuItem key={eventType.value} value={eventType.value}>
              {formatEventType(eventType.value)}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
      <Stack width={150}>
        <TextField select label="Status" value={filters.status} onChange={handleStatusChange} size="small" fullWidth>
          <MenuItem value={DELIVERY_LOG_STATUS.ALL}>All</MenuItem>
          <MenuItem value={DELIVERY_LOG_STATUS.SUCCESS}>Success</MenuItem>
          <MenuItem value={DELIVERY_LOG_STATUS.FAILURE}>Failed</MenuItem>
        </TextField>
      </Stack>
    </Stack>
  );
}

DeliveryLogsFilters.propTypes = {
  filters: PropTypes.shape({
    eventType: PropTypes.string,
    status: PropTypes.string.isRequired,
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
};
